export const LAST_SEARCH_KEY = 'last-searchs'
export const SEARCH_HISTORY_LIMIT = 10
